import categorySaga from "./category.saga";
import productSaga from "./product.saga";

const sagaList = [productSaga, categorySaga]

export default sagaList;
